import { ErrorMessage, Field } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { handleKeyAlphaNumeric } from '../../../CommonUtilities/Validations/RegularExpAndVar';

export default function CasteDetails(props) {
    const { Formik, showOtpBtn } = props;
    const [certificateId, setMeesevano] = useState("");
    const [manualMeeseva, setManualMeeseva] = useState("");
    const [meesevaError, setMeesevaError] = useState("");

    if (certificateId === null) {
        setMeesevano("");
    }
    // const flag = localStorage.getItem("flagg")

    const getStudyData = () => {
        let url = config.url.DSC_URL + "candidate-study-details";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true && res?.data?.candidatereg_status === true) {
                const certId = res?.data?.candidatereg[0]?.certificate_id;
                if (certId) {
                    localStorage.setItem("caste", certId);
                    setMeesevano(certId);
                    setManualMeeseva(certId);
                }
            }
        });
    };

  const getCasteDetailsABC = (certificateId) => {
        if (certificateId && certificateId.trim()) {
            let payload = { certificateId: certificateId.trim() };
            let url = config.url.DSC_URL + "candidate-caste-certificate";
            CommonAxiosPost(url, payload)
                .then((response) => {
                    if (response?.data?.status === true) {
                        let resObj = response?.data?.data;
                        Formik.setFieldValue("certificateId", certificateId);
                        Formik.setFieldValue("casteApplicantName", resObj?.name);
                        Formik.setFieldValue("casteDistrict", resObj?.district);
                        Formik.setFieldValue("casteMandal", resObj?.mandal);
                        Formik.setFieldValue("casteDetails", resObj?.caste);
                        Formik.setFieldValue("certificateCaste", resObj?.caste);
                        Formik.setFieldValue("certificateSubCaste", resObj?.sub_caste);
                        setMeesevaError("");
                    } else {
                        setMeesevaError(response?.data?.sdesc || "Invalid Certificate No.");
                        Formik.setFieldValue("certificateId", "");
                    }
                })
                .catch((error) => {
                    console.error("Error fetching caste details:", error);
                    setMeesevaError("Error validating certificate. Please try again.");
                });
        }
    };

    useEffect(() => {
        getStudyData();

        const casteFromStorage = localStorage.getItem("caste");
        if (casteFromStorage && casteFromStorage.trim() !== "") {
            setMeesevano(casteFromStorage);
            setManualMeeseva(casteFromStorage);

            // preloadCasteData();
        }
    }, []); // eslint-disable-line

    useEffect(() => {
        if (certificateId && certificateId.trim() !== "" && certificateId !== "null") {
            getCasteDetailsABC(certificateId);
        }
    }, [certificateId]); // eslint-disable-line

    const handleManualMeesevaChange = (e) => {
        const val = e.target.value;
        setManualMeeseva(val);
        Formik.setFieldValue("certificateId", val); Formik.setFieldValue("casteDetails", '');
        Formik.setFieldValue("casteMandal", ''); Formik.setFieldValue("certificateSubCaste", ''); Formik.setFieldValue("casteApplicantName", '');
        Formik.setFieldValue("certificateCaste", ''); Formik.setFieldValue("casteDistrict", '');
        setMeesevaError(""); // clear error on change
    };

    const handleGetDetailsClick = () => {
        const trimmed = manualMeeseva?.trim();
        if (trimmed) {
            setMeesevano(trimmed);
        }
    };


    return (
        <div>
            <div className="personal-head mt-2">
                <span>Caste Details</span>
            </div>
            <div className="personal-row personal-roweducation">
                <div className="p-3 mb-3" style={{ background: "#ffffff", borderRadius: "8px", border: "1px solid #e3e3e3", maxWidth: "1600px", margin: "0 auto" }}>
                    <Form>
                        <Row className="g-3 align-items-end">
                            <Col xs={12} md={6} lg={4}>
                                <Form.Label className="input-lable mb-1">
                                    Caste Certificate Number
                                </Form.Label>
                                <InputGroup>
                                    <Field
                                        disabled={showOtpBtn === false}
                                        type="text"
                                        className={`form-control${meesevaError ? " is-invalid" : ""}`}
                                        name="certificateId"
                                        maxLength="20"
                                        onKeyPress={(e) => { handleKeyAlphaNumeric(e) }}
                                        onChange={(e) => { handleManualMeesevaChange(e) }}
                                        style={{ fontSize: 15 }}
                                        autoComplete="off"

                                    />

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm ms-2"
                                        style={{ minWidth: 100 }}
                                        onClick={() => { handleGetDetailsClick() }}>
                                        Get Details
                                    </button>
                                </InputGroup>
                                {meesevaError && (
                                    <div className="text-error mt-1" style={{ color: "#d9534f", fontSize: 14 }}>
                                        {meesevaError}
                                    </div>
                                )}
                                <ErrorMessage name="certificateId" component="div" className="text-error mt-1" />
                            </Col>
                            <Col xs={12} md={6} lg={4}>
                                <Form.Label className="input-lable mb-1">Applicant Name in Certificate</Form.Label>
                                <div className="form-control bg-light" style={{ minHeight: 38, fontSize: 15 }}>
                                    {Formik.values.casteApplicantName || ""}
                                </div>
                            </Col>

                        </Row>
                        <Row className="g-3 mt-1">
                            <Col xs={12} md={6} lg={3}>
                                <Form.Label className="input-lable mb-1">Caste</Form.Label>
                                <div className="form-control bg-light" style={{ minHeight: 38, fontSize: 15 }}>
                                    {Formik.values.casteDetails || ""}
                                </div>
                                <ErrorMessage name="certificateCaste" component="div" className="text-error mt-1" />
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <Form.Label className="input-lable mb-1">Sub Caste</Form.Label>
                                <div className="form-control bg-light" style={{ minHeight: 38, fontSize: 15 }}>
                                    {Formik.values.certificateSubCaste || ""}
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <Form.Label className="input-lable mb-1">District</Form.Label>
                                <div className="form-control bg-light" style={{ minHeight: 38, fontSize: 15 }}>
                                    {Formik.values.casteDistrict || ""}
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <Form.Label className="input-lable mb-1">Mandal</Form.Label>
                                <div className="form-control bg-light" style={{ minHeight: 38, fontSize: 15 }}>
                                    {Formik.values.casteMandal || ""}
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </div>
    );
}
